import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';
import moment from 'moment';

import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import FaceIcon from '@material-ui/icons/Face';

import Chip from '@material-ui/core/Chip';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import LinkMaterial from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

import Paper from '~/components/Paper';
import Table from '~/components/Table/Table';
import tableStyles from '~/components/Table/Table/styles';

import Request from '~/providers/Request';
import {
  showPerson,
  showSpecialty,
  showAppointmentCategories,
  showMedicalAppointments,
} from '~/config/routes';

const MedicalAppointments = ({ idClient }) => {
  const { t } = useTranslation();
  const classesTable = tableStyles();

  const [loading, setLoading] = useState(false);
  const [medicalAppointments, setMedicalAppointments] = useState([]);

  async function getMedicalAppointments() {
    setLoading(true);

    Request.get(
      `/admin/users/${idClient}/medical_appointments`,
      {},
      { normalizeJSON: true }
    )
      .then((response) => {
        const { data } = response;
        setLoading(false);
        setMedicalAppointments(data);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  useEffect(() => {
    if (idClient) {
      getMedicalAppointments();
    }
  }, [idClient]);

  return (
    <Paper
      Icon={LocalHospitalIcon}
      iconColor="blue"
      title={t('person.tabs.medical_appointments')}
    >
      <Typography variant="subtitle2" color="primary">
        <strong>{t('person.extras.count_appointments')}: </strong>
        {medicalAppointments.length}
      </Typography>
      <Table
        emptyData={medicalAppointments.length === 0}
        loading={loading}
        columns={
          <>
            <TableCell className={classesTable.cell}>
              {t('medicalAppointments.attributes.id')}
            </TableCell>
            <TableCell className={classesTable.cell}>
              {t('medicalAppointments.attributes.created_at')}
            </TableCell>
            <TableCell className={classesTable.cell}>
              {t('medicalAppointments.attributes.doctor')}
            </TableCell>
            <TableCell className={classesTable.cell}>
              {t('medicalAppointments.attributes.attendant')}
            </TableCell>
            <TableCell className={classesTable.cell}>
              {t('medicalAppointments.attributes.category')}
            </TableCell>
            <TableCell className={classesTable.cell}>
              {t('medicalAppointments.attributes.specialty')}
            </TableCell>
            <TableCell className={classesTable.cell}>
              {t('medicalAppointments.attributes.appointment_at')}
            </TableCell>
          </>
        }
      >
        {medicalAppointments.map((row) => {
          return (
            <TableRow key={row.id} hover className={classesTable.row}>
              <TableCell>
                <Chip
                  label={row.id}
                  component={LinkMaterial}
                  href={showMedicalAppointments.reverse({
                    id: row.id,
                  })}
                  style={{ cursor: 'pointer' }}
                  target="_blank"
                  color="primary"
                  variant="outlined"
                  onDelete={() => {}}
                  deleteIcon={<OpenInNewIcon />}
                />
              </TableCell>
              <TableCell>
                {row.created_at
                  ? moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')
                  : null}
              </TableCell>
              <TableCell>
                {row.doctor ? (
                  <Chip
                    icon={<FaceIcon />}
                    label={dig(row, 'doctor', 'name')}
                    component={LinkMaterial}
                    href={showPerson.reverse({
                      id: dig(row, 'doctor', 'id'),
                    })}
                    style={{ cursor: 'pointer' }}
                    target="_blank"
                    color="primary"
                    variant="outlined"
                    onDelete={() => {}}
                    deleteIcon={<OpenInNewIcon />}
                  />
                ) : null}
              </TableCell>
              <TableCell>
                {row.attendant ? (
                  <Chip
                    icon={<FaceIcon />}
                    label={dig(row, 'attendant', 'name')}
                    component={LinkMaterial}
                    href={showPerson.reverse({
                      id: dig(row, 'attendant', 'id'),
                    })}
                    style={{ cursor: 'pointer' }}
                    target="_blank"
                    color="primary"
                    variant="outlined"
                    onDelete={() => {}}
                    deleteIcon={<OpenInNewIcon />}
                  />
                ) : null}
              </TableCell>
              <TableCell>
                {row.category ? (
                  <Chip
                    label={dig(row, 'category', 'name')}
                    component={LinkMaterial}
                    href={showAppointmentCategories.reverse({
                      id: dig(row, 'category', 'id'),
                    })}
                    style={{ cursor: 'pointer' }}
                    target="_blank"
                    color="secondary"
                    variant="outlined"
                    onDelete={() => {}}
                    deleteIcon={<OpenInNewIcon />}
                  />
                ) : null}
              </TableCell>
              <TableCell>
                {row.specialty ? (
                  <Chip
                    label={dig(row, 'specialty', 'name')}
                    component={LinkMaterial}
                    href={showSpecialty.reverse({
                      id: dig(row, 'specialty', 'id'),
                    })}
                    style={{ cursor: 'pointer' }}
                    target="_blank"
                    color="secondary"
                    variant="outlined"
                    onDelete={() => {}}
                    deleteIcon={<OpenInNewIcon />}
                  />
                ) : null}
              </TableCell>
              <TableCell>
                {row.schedule_appointment_at
                  ? moment(row.schedule_appointment_at).format(
                      'DD/MM/YYYY HH:mm:ss'
                    )
                  : null}
              </TableCell>
            </TableRow>
          );
        })}
      </Table>
    </Paper>
  );
};

export default React.memo(MedicalAppointments);
